import type {
  AcceptInviteMeta,
  AcceptMapInviteFailedPayload,
  ChangeInvitePermissionMeta,
  CreateLinkMeta,
  Invite,
  InviteMeta,
  MapRemoveInviteMeta,
} from "domains/createShareSettings/types";
import type {
  DirectTopicAccessControlGroups,
  TopicAccessInviteResponse,
  TopicAccessInviteTokenResponse,
} from "domains/topicshare/topicshare.types";
import type { ErrorMeta, ErrorPayload } from "types/redux";

export enum MapShareType {
  INVITE = "domains/MAP_SHARE_INVITE",
  INVITE_FULFILLED = "domains/MAP_SHARE_INVITE_FULFILLED",
  INVITE_REJECTED = "domains/MAP_SHARE_INVITE_REJECTED",
  ACCESS_LIST = "domains/MAP_ACCESS_LIST",
  ACCESS_LIST_FULFILLED = "domains/MAP_ACCESS_LIST_FULFILLED",
  ACCESS_LIST_REJECTED = "domains/MAP_ACCESS_LIST_REJECTED",
  REMOVE_INVITE = "domains/MAP_SHARE_REMOVE_INVITE",
  REMOVE_INVITE_FULFILLED = "domains/MAP_SHARE_REMOVE_INVITE_FULFILLED",
  REMOVE_INVITE_REJECTED = "domains/MAP_SHARE_REMOVE_INVITE_REJECTED",
  CHANGE_INVITE_PERMISSION = "domains/MAP_SHARE_CHANGE_PERMISSION",
  CHANGE_INVITE_PERMISSION_FULFILLED = "domains/MAP_SHARE_CHANGE_PERMISSION_FULFILLED",
  CHANGE_INVITE_PERMISSION_REJECTED = "domains/MAP_SHARE_CHANGE_PERMISSION_REJECTED",
  CREATE_LINK = "domains/MAP_SHARE_CREATE_LINK",
  CREATE_LINK_FULFILLED = "domains/MAP_SHARE_CREATE_LINK_FULFILLED",
  CREATE_LINK_REJECTED = "domains/MAP_SHARE_CREATE_LINK_REJECTED",
  OPEN_MAP_INVITATION = "domains/OPEN_MAP_INVITATION",
  OPEN_MAP_INVITATION_FULFILLED = "domains/OPEN_MAP_INVITATION_FULFILLED",
  OPEN_MAP_INVITATION_REJECTED = "domains/OPEN_MAP_INVITATION_REJECTED",
  ACCEPT_INVITE = "domains/ACCEPT_MAP_INVITATION",
  ACCEPT_INVITE_FULFILLED = "domains/ACCEPT_MAP_INVITATION_FULFILLED",
  ACCEPT_INVITE_REJECTED = "domains/ACCEPT_MAP_INVITATION_REJECTED",
}

export type MapInviteDefaultAction = { meta: InviteMeta; type: MapShareType.INVITE };
export type MapInviteFulfilledAction = { meta: InviteMeta; payload: Invite[]; type: MapShareType.INVITE_FULFILLED };
export type MapInviteRejectedAction = { meta: InviteMeta; type: MapShareType.INVITE_REJECTED };
export type MapAccessListDefaultAction = { meta: { id: string }; type: MapShareType.ACCESS_LIST };

export type MapAccessListFulfilledAction = {
  payload: DirectTopicAccessControlGroups;
  type: MapShareType.ACCESS_LIST_FULFILLED;
};

export type MapAccessListRejectedAction = { meta: { id: string }; type: MapShareType.ACCESS_LIST_REJECTED };
export type MapRemoveInviteDefaultAction = { meta: MapRemoveInviteMeta; type: MapShareType.REMOVE_INVITE };
export type MapRemoveInviteFulfilledAction = { meta: MapRemoveInviteMeta; type: MapShareType.REMOVE_INVITE_FULFILLED };
export type MapRemoveInviteRejectedAction = { meta: MapRemoveInviteMeta; type: MapShareType.REMOVE_INVITE_REJECTED };

export type ChangeInvitePermissionDefaultAction = {
  meta: ChangeInvitePermissionMeta;
  type: MapShareType.CHANGE_INVITE_PERMISSION;
};

export type ChangeInvitePermissionFulfilledAction = {
  meta: ChangeInvitePermissionMeta;
  type: MapShareType.CHANGE_INVITE_PERMISSION_FULFILLED;
};

export type ChangeInvitePermissionRejectedAction = {
  meta: ChangeInvitePermissionMeta;
  type: MapShareType.CHANGE_INVITE_PERMISSION_REJECTED;
};

export type CreateInviteLinkDefaultAction = { meta: CreateLinkMeta; type: MapShareType.CREATE_LINK };

export type CreateInviteLinkFulfilledAction = {
  meta: CreateLinkMeta;
  payload: TopicAccessInviteResponse;
  type: MapShareType.CREATE_LINK_FULFILLED;
};

export type CreateInviteLinkRejectedAction = { meta: CreateLinkMeta; type: MapShareType.CREATE_LINK_REJECTED };
export type OpenMapInvitationDefaultAction = { meta: { token: string }; type: MapShareType.OPEN_MAP_INVITATION };

export type OpenMapInvitationFulfilledAction = {
  payload: TopicAccessInviteTokenResponse;
  type: MapShareType.OPEN_MAP_INVITATION_FULFILLED;
};

export type OpenMapInvitationRejectedAction = {
  meta: ErrorMeta;
  payload: ErrorPayload;
  type: MapShareType.OPEN_MAP_INVITATION_REJECTED;
};
export type AcceptMapInviteDefaultAction = { meta: AcceptInviteMeta; type: MapShareType.ACCEPT_INVITE };
export type AcceptMapInviteFulfilledAction = { meta: AcceptInviteMeta; type: MapShareType.ACCEPT_INVITE_FULFILLED };
export type AcceptMapInviteRejectedAction = {
  meta: AcceptMapInviteFailedPayload;
  type: MapShareType.ACCEPT_INVITE_REJECTED;
};

export type MapShareAction =
  | MapInviteDefaultAction
  | MapInviteFulfilledAction
  | MapInviteRejectedAction
  | MapAccessListDefaultAction
  | MapAccessListFulfilledAction
  | MapAccessListRejectedAction
  | MapRemoveInviteDefaultAction
  | MapRemoveInviteFulfilledAction
  | MapRemoveInviteRejectedAction
  | ChangeInvitePermissionDefaultAction
  | ChangeInvitePermissionFulfilledAction
  | ChangeInvitePermissionRejectedAction
  | CreateInviteLinkDefaultAction
  | CreateInviteLinkFulfilledAction
  | CreateInviteLinkRejectedAction
  | OpenMapInvitationDefaultAction
  | OpenMapInvitationFulfilledAction
  | OpenMapInvitationRejectedAction;
